export default {
    state: {
        title: 'TRIB',
        theme: localStorage.getItem('theme') || 'light',
        isSidebarActive: (localStorage.getItem('sidebarActive') || 'false') === 'true',
        isSidebarReduced: (localStorage.getItem('sidebarReduced') || 'false') === 'true',
        sidebarWidth: localStorage.getItem('sidebarWidth') || "default",
        themeColor: localStorage.getItem('themeColor') || "#2962ff"
    },
    mutations: {
        //This is for Sidebar trigger in mobile
        TOGGLE_SIDEBAR_ACTIVE(state, val) {
            state.isSidebarActive = val;
            localStorage.setItem('sidebarActive', val);
        },
        //This is for Sidebar toggle in desktop
        TOGGLE_REDUCE_SIDEBAR(state, val) {
            state.isSidebarReduced = val;
            localStorage.setItem('sidebarReduced', val);
        },
        UPDATE_THEME(state, val) {
            state.theme = val;
            localStorage.setItem('theme', val);
        },
        UPDATE_THEME_COLOR(state, val) {
            state.themeColor = val;
            localStorage.setItem('themeColor', val);
        },
        UPDATE_SIDEBAR_WIDTH(state, width) {
            state.sidebarWidth = width;
            localStorage.setItem('sidebarWidth', width);
        },
        SET_TITLE(state, title) {
            state.title = title;
            window.document.title = process.env.VUE_APP_DOMAIN_TITLE + ' | ' + (title || 'Advanced ROI');
        }
    },
    actions: {
        updateSidebarWidth({ commit }, width) {
            commit('UPDATE_SIDEBAR_WIDTH', width);
        }
    },
    getters:{
        getSidebarWidth: (state) => state.sidebarWidth
    }
}
